import { RequestService } from 'Utils/Api';
import { logger } from 'Utils/Logger';
import { getDefaultConfig } from 'Utils/Store';

export const getDppContent = async (name) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  const url = `${foxApi}/screens/${name}`;
  try {
    logger.apiRequest('getDppContent', url);
    const { data } = await RequestService.send({
      url,
      method: 'GET',
      customHeaders: { 'x-api-key': accountApiKey },
    });
    logger.apiResponse('getDPPContent', data);
    return data && data.panels ? data.panels.member : [];
  } catch (error) {
    logger.apiError('getDPPContent', url, error);
    return [];
  }
};
